import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import RightArrowIcon from 'prizm-icons/lib/16px/Indicator/column/Range';
import { EventTypes } from '4ff-lib-foundation/lib/AppFrame/publicAPI/services';
import { LAYOUT_LEVELS } from '../../constants';
import { trackEvent } from '../../utils';
import history from '../../services/history';
import queryString from '../../services/queryString';
import { Node, Overlay, Arrow, Link, ImgBox, Info, Title, Description, Abbr } from './styles';

class Tile extends PureComponent {
  static propTypes = {
    node: PropTypes.object.isRequired,
    level: PropTypes.oneOf([LAYOUT_LEVELS.module, LAYOUT_LEVELS.item]), // eslint-disable-line
    location: PropTypes.object.isRequired,
  }

  state = {
    isImageBroken: false,
  };

  get nodeURI() {
    return this.props.level
      ? `${window.location.href}&${this.props.level}=${this.props.node.id}`
      : this.props.node.uri;
  }

  get targetURI() {
    return this.props.node.uri === this.nodeURI
      && this.props.node.meta
      && this.props.node.meta.newTab
      ? '_blank'
      : '_self';
  }

  getAbbr = name => name.split(' ').map(word => word.charAt(0)).join('');

  handleImageLoadingError = () => {
    this.setState({ isImageBroken: true });
  };

  handleClick = () => {
    const nodeURL = new URL(this.nodeURI || '', window.location.origin);

    trackEvent(
      'LPB',
      EventTypes.NAVIGATION,
      'Click on LPB Tile',
      'Redirect',
      {
        url: nodeURL.pathname,
        host: nodeURL.host,
        hash: nodeURL.hash,
        query: nodeURL.search,
      },
    );

    if (this.targetURI === '_self' && this.props.level) {
      const query = queryString.parse(this.props.location.search);
      query[this.props.level] = this.props.node.id;
      history.push({
        pathname: this.props.location.pathname,
        search: queryString.stringify(query),
      });
    } else {
      setTimeout(() => { window.open(this.nodeURI, this.targetURI); }, 300);
    }
  }

  render() {
    const { node } = this.props;

    return (
      <Node data-test-tile-element={node.label}>
        <Link // eslint-disable-line
          onClick={this.handleClick}
        >
          <ImgBox>
            {!this.state.isImageBroken && (node.thumbnail || node.icon)
              ? <img src={node.thumbnail || node.icon} alt="capture" onError={this.handleImageLoadingError} />
              : <Abbr>{this.getAbbr(node.label)}</Abbr>
            }
            <Overlay>
              <Arrow>
                <RightArrowIcon width={36} height={36} color="#3b73b3" />
              </Arrow>
            </Overlay>
          </ImgBox>
          <Info>
            <Title>{node.label}</Title>
            <Description>{node.desc}</Description>
          </Info>
        </Link>
      </Node>
    );
  }
}

export default withRouter(Tile);
